import http from "../http";
import { API_BASE_URL } from "../../config";

export default class AuthService {
  static loginAdmin(payload) {
    return http
      .post(`${API_BASE_URL}/v2/auth/admins/login`, payload)
      .then((response) => response.data);
  }

  static sendToOwnerOTP(payload) {
    return http.post(`${API_BASE_URL}/v2/owners/reset-password/send-otp`, payload);
  }

  static getCurrentOwner() {
    return http
      .get(`${API_BASE_URL}/v2/owners/current/user`)
      .then((response) => response.data);
  }

  static getOwnerProfile(ownerId) {
    return http
      .get(`${API_BASE_URL}/v2/owners/${ownerId}`)
      .then((response) => response.data);
  }
  static getOwnerList(page, limit) {
    return http
      .get(`${API_BASE_URL}/v2/owners`, { params: { page, limit } })
      .then((response) => response.data);
  }

  static logout() {
    return http
      .post(`${API_BASE_URL}/v2/auth/owners/logout`)
      .then((response) => response);
  }

  static forgotPassword(type, payload) {
    return http.post(`${API_BASE_URL}/v2/${type}s/reset-password/send-otp`, payload);
  }

  static resetOwnerPassword(token, payload) {
    return http.post(`${API_BASE_URL}/v2/owners/reset-password/${token}`, payload);
  }

  static resetPasswordByOTP(token, payload) {
    return http.post(`${API_BASE_URL}/v2/reset-password/mobile`, payload);
  }

  static signUp(payload) {
    return http.post(`${API_BASE_URL}/v2/auth/owners/sign-up`, payload);
  }

  static updateProfile(id, payload) {
    return http
      .put(`${API_BASE_URL}/v2/owners/${id}`, payload)
      .then((response) => response);
  }

  static verifyOTP(userId, payload) {
    return http.put(`${API_BASE_URL}/v2/auth/owners/mobile/verify/${userId}`, payload);
  }

  static verifyOTPWhenForgetPassword(payload) {
    return http.post(
      `${API_BASE_URL}/v2/owners/forgot-password/otp/verify`,
      payload
    );
  }

  static verifyDriver = (adminId, driverId) => {
    // TODO
    return http.put(
      `${API_BASE_URL}/v2/admins/${adminId}/verify/drivers/${driverId}`
    );
  };

  static verifyOwner = (adminId, ownerId) => {
    // TODO
    return http.put(
      `${API_BASE_URL}/v2/admins/${adminId}/verify/owners/${ownerId}`
    );
  };

  static verifySocialAccount(payload, type) {
    console.log(type, payload);
    return http.post(`${API_BASE_URL}/v2/auth/${type}/callback/mobile`, payload);
  }

  static getCurrentUser() {
    return http
      .get(`${API_BASE_URL}/v2/auth/current-user`)
      .then((response) => response.data);
  }

  static updateFirebaseToken(payload) {
    return http
      .put(`${API_BASE_URL}/v2/firebase`, payload)
      .then((response) => response.data);
  }

  static uploadProfilePicture = (userId, payload) => {
    return http
      .post(`${API_BASE_URL}/v2/users/${userId}/picture`, payload)
      .then((res) => res.data);
  };

  static uploadImage = (payload) => {
    return http
      .post(`${API_BASE_URL}/v2/upload/private/s3`, payload)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log("upload", err);
      });
  };
  static updateMobile = (userId, payload) =>
    http.put(`${API_BASE_URL}/v2/users/mobile/${userId}`, payload);

  static removeMobile(user) {
    return http.put(`${API_BASE_URL}/v2/users/remove-mobile/${user._id}`, user);
  }

  static isRegistered = () =>
    http.get(`${API_BASE_URL}/v2/scholarship/registered`).then((res) => res.data);

  static isExistUser = (mobile) =>
    http.get(`${API_BASE_URL}/v2/auth/owners/exists/${mobile}`).then((res) => res.data);

  static banUser = (payload) =>
    http.post(`${API_BASE_URL}/v2/auth/ban-user`, payload).then((res) => res.data);
}
